import { ComponentPropsWithRef, forwardRef } from 'react';

export const DropdownWithArrow = forwardRef<SVGSVGElement, ComponentPropsWithRef<'svg'>>(({ ...rest }, ref) => {
  return (
    <svg ref={ref} width="87" height="140" viewBox="0 0 87 165" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.142 1.507c-1.153-2.01-4.052-2.01-5.205 0L35.639 9H32C14.327 9 0 23.327 0 41v92c0 17.673 14.327 32 32 32h23c17.673 0 32-14.327 32-32V41C87 23.327 72.673 9 55 9h-5.561z"
          fill="#fff"
        />
      </g>
      <defs></defs>
    </svg>
  );
});

DropdownWithArrow.displayName = 'DropdownWithArrow';
